import firebase from "datastore/database";

export default async function fetchCollection(path) {
  const snap = await firebase
    .firestore()
    .collection(path)
    .get();
  return snap.docs.map((item) => ({ ...item.data(), uid: item.id }));
}
